import script from "./DefaultProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./DefaultProjectCard.vue?vue&type=style&index=0&id=13475abe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13475abe"]])

export default __exports__